import { Field } from 'formik';
import { motion } from 'framer-motion';
import React from 'react';
import InlineAutocompleteComponent from './InlineAutocomplete';

export default function FormField(props) {
  const { name = '', label = '', className = '', inputClassName = '', i, validMessage = '', ...other } = props;

  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        const hasError = meta.touched && meta.error;
        let defaultFieldClasses = `w-full text-16px px-3 py-2 bg-[#F8F8F8] rounded border-[0.25px] border-[#d9d9d9] `;
        if (hasError) {
          defaultFieldClasses += `!border-yellow`;
        }

        return (
          <motion.label
            key={name}
            initial={{ opacity: 0 }}
            transition={{ delay: 0.2 + i / 9 }}
            animate={{ opacity: 1 }}
            className={`!block !w-full ${className} ${props.as === 'hidden' ? 'absolute z-[-1]' : ''}`}>
            {label && <div className="font-bold text-14px mb-1" dangerouslySetInnerHTML={{ __html: label }} />}

            <div>
              {(!props.as || props.as === 'input') && (
                <input type={props.type || 'text'} className={`${defaultFieldClasses} ${inputClassName}`} placeholder={props.placeholder} {...field} {...other} />
              )}

              {props.as === 'textarea' && <textarea className={`${defaultFieldClasses} ${inputClassName}`} {...field} {...other} />}

              {props.as === 'select' && (
                <select className={`v2 ${defaultFieldClasses} ${inputClassName} ${!meta?.value?.length ? 'not-selected' : 'has-selected'} `} {...field} {...other}>
                  {props.options.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              )}

              {props.as === 'hidden' && <input type={'hidden'} {...field} {...other} />}

              {props.as === 'readonlyemail' && (
                <input type={'email'} className={`${defaultFieldClasses} ${inputClassName}`} {...field} {...other} value={form.values.email} readOnly />
              )}

              {props.as === 'inline-autocomplete' && (
                <InlineAutocompleteComponent className={`${defaultFieldClasses} ${inputClassName}`} {...field} {...other} form={form} />
                // <input type={'email'} className={`${defaultFieldClasses} ${inputClassName}`} {...field} {...other} value={form.values.email} readOnly />
              )}

              {props.as === 'horizontal-radio' && (
                <>
                  <input type="hidden" {...field} {...other} />

                  <div className={`grid sm:grid-cols-3 gap-3 ${props.name === 'type' ?'-mx-5': ''} ${props.name === 'servesPerMonth' ? 'my-6': ''}`}>
                    {props?.options?.map(option => (
                      <div
                        onClick={() => form.setFieldValue(props.name, option.value)}
                        className={`${
                          form.values[props.name] === option.value ? 'bg-dark-blue text-white' : ''
                        } form-button px-4 flex items-center text-center justify-center cursor-pointer`}
                        key={option.value}>
                        <div className={`mr-2 rounded-full ${form.values[props.name] === option.value ? 'bg-white' : ''}`} style={{ flex: '0 0 16px' }}>
                          <svg
                            className={`rounded-full ${form.values[props.name] === option.value ? 'bg-yellow transform scale-50' : ''}`}
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.5ZM8 14C4.685 14 2 11.315 2 8C2 4.685 4.685 2 8 2C11.315 2 14 4.685 14 8C14 11.315 11.315 14 8 14Z"
                              fill={form.values[props.name] === option.value ? 'transparent' : '#C0C0C0'}
                            />
                          </svg>
                        </div>

                        <div className="text-14px flex-auto select-none" dangerouslySetInnerHTML={{ __html: option.label }} />
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>

            {hasError && <motion.div className={`mt-1 text-14px font-medium text-yellow ${props.as === 'horizontal-radio' ? 'text-center': ''}`}>{meta.error}</motion.div>}
            {!hasError && meta?.touched === true && validMessage?.length > 0 ? (
              <motion.div className="mt-1 text-14px flex items-center" style={{ color: '#8AC58A' }}>
                <svg className="mr-2" width="16" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.667 1L5.5 10.167 1.333 6" stroke="green" strokeOpacity=".46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span dangerouslySetInnerHTML={{ __html: validMessage }} />
              </motion.div>
            ) : null}
          </motion.label>
        );
      }}
    </Field>
  );
}
